import { useState } from 'react';
import { FullWidthContent, MainMenuLayout } from '@layouts';
import { SelectCustomerCard } from '@organisms';
import useCustomersByProduct from './data/useCustomersByProduct';
import UploadFile from './modules/UploadFile';

/** Nameless cards screen */
const NamelessCardsScreen = () => {
  const [isLoading, setLoading] = useState(false);
  const { data } = useCustomersByProduct({ product: 'GiftCard' });
  return (
    <MainMenuLayout>
      <FullWidthContent>
        <SelectCustomerCard disabled={isLoading} customOptions={data} />
        <UploadFile isLoading={isLoading} setLoading={setLoading} />
      </FullWidthContent>
    </MainMenuLayout>
  );
};

export default NamelessCardsScreen;
